import RoutesMap from '../../route_control/RouteControl'
import { PaymentPage, PaymentResult } from '../../pages/payment'

export const PaymentRouteImport = {
    RoutesMap,
    PaymentPage,
    PaymentResult,
}
